import React from 'react';
import { strings } from '../../../../../resources/strings';
import { DiagnosticInformation } from '../../../../../models/DiagnosticInformation';
import { Field, FieldType } from '../../../../../common-components/Field/Field';
import { Table } from '../../../../../common-components/Table/Table';
import { TableData } from '../../../../../common-components/TableData/TableData';
import { TableHead } from '../../../../../common-components/TableHead/TableHead';
import { TableRow } from '../../../../../common-components/TableRow/TableRow';
import { Container, DiagnosticTitle } from './styles';

interface IDiagnosticProps {
  typeDescription: string;
  values?: DiagnosticInformation;
  marginBottom?: string;
  change: (values: DiagnosticInformation) => void;
}

const TableHeadDiagnostic = (
  {children}: {children?: React.ReactNode}
) => <TableHead normalText backgroundColor='#f5f5f5' borderStyle='1px solid #ddd' textColor='#000' textAlign='center'>{children}</TableHead>;

const TableDataDiagnostic = (
  {children}: {children?: React.ReactNode}
) => <TableData borderStyle='1px solid #ddd' textAlign='center'>{children}</TableData>;

const Diagnostic: React.FC<IDiagnosticProps> = ({
  typeDescription,
  values,
  marginBottom,
  change
}) => {

  return (
    <Container marginBottom={marginBottom}>
      <DiagnosticTitle>{typeDescription}</DiagnosticTitle>
      <Table>
        <thead>
          <TableRow>
            <TableHeadDiagnostic>{strings.Eye}</TableHeadDiagnostic>
            <TableHeadDiagnostic>{strings.Spherical}</TableHeadDiagnostic>
            <TableHeadDiagnostic>{strings.Cylindrical}</TableHeadDiagnostic>
            <TableHeadDiagnostic>{strings.Axis}</TableHeadDiagnostic>
            <TableHeadDiagnostic>{strings.DNP}</TableHeadDiagnostic>
          </TableRow>
        </thead>
        <tbody>
          <TableRow>
            <TableDataDiagnostic>{strings.Right}</TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.rightSpherical}
                change={(value) => changeValue('rightSpherical', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.rightCylindrical}
                change={(value) => changeValue('rightCylindrical', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.rightAxis}
                change={(value) => changeValue('rightAxis', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.rightNasoPupillaryDistance}
                change={(value) => changeValue('rightNasoPupillaryDistance', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
          </TableRow>
          <TableRow>
            <TableDataDiagnostic>{strings.Left}</TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.leftSpherical}
                change={(value) => changeValue('leftSpherical', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.leftCylindrical}
                change={(value) => changeValue('leftCylindrical', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.leftAxis}
                change={(value) => changeValue('leftAxis', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
            <TableDataDiagnostic>
              <Field
                type={FieldType.Text}
                value={values?.leftNasoPupillaryDistance}
                change={(value) => changeValue('leftNasoPupillaryDistance', value)}
                marginRight='0px' marginTop='0px' marginBottom='px'
              />
            </TableDataDiagnostic>
          </TableRow>
        </tbody>
      </Table>
    </Container>
  );

  function changeValue(field: string, value: any) {
    if (!values) values = new DiagnosticInformation();
    (values as any)[field] = value;
    change({ ...values });
  }
}

export { Diagnostic };